(ns frontend.ui.page.lp-portal.report.event
  (:require
   [common.schema.entities.lp-portal.lp-report-holding :as lp-report-holding]
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [frontend.lp-portal.sub :as portal-sub]
   [ajax.core :as ajax]
   [frontend.ui.page.lp-portal.report.sub :as sub]))

(rf/reg-event-fx
 ::report-loaded
 (fn [{db :db} [_ resp]]
   {:db (-> db
            (p/dissoc-in [::sub/loading?])
            (assoc-in sub/report-path (:lp-report (:body resp)))
            (assoc-in sub/materials-path (:material-files (:body resp)))
            (assoc-in sub/accessible-investor-attachments-path
                      (:accessible-investor-attachments (:body resp)))
            (assoc-in sub/images-path (:report-images (:body resp)))
            (assoc-in sub/burned-pdfs-path (:burned-pdfs (:body resp)))
            (assoc-in sub/export-formats-path (:export-formats (:body resp)))
            (assoc-in sub/holding-reports-path
                      (some->> resp
                               :body
                               :holding-reports
                               (sort lp-report-holding/compare-holdings))))}))

(rf/reg-event-fx
 ::report-load-failed
 (fn [{db :db} [_ err]]
   (js/console.log "REPORT load failed : " err)
   {:db (p/dissoc-in db [::sub/loading?])}))

(rf/reg-event-fx
 ::load-report
 (fn [{db :db} [_ report-id]]
   (let [app-loaded? (get-in db portal-sub/app-config-path)]
     (if app-loaded?
       {:db         (-> db
                        (assoc-in [::sub/loading?] true)
                        (p/dissoc-in sub/report-path)
                        (p/dissoc-in sub/materials-path)
                        (p/dissoc-in sub/accessible-investor-attachments-path)
                        (p/dissoc-in sub/images-path)
                        (p/dissoc-in sub/holding-reports-path))
        :http-xhrio {:method          :post
                     :uri             "/lp-portal/api/get-fund-report"
                     :params          {:report-id report-id}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::report-loaded]
                     :on-failure      [::report-load-failed]}}
       {:db (-> db
                (assoc-in [::sub/loading?] true)
                (p/dissoc-in sub/report-path)
                (p/dissoc-in sub/materials-path)
                (p/dissoc-in sub/accessible-investor-attachments-path)
                (p/dissoc-in sub/images-path)
                (p/dissoc-in sub/holding-reports-path)
                (assoc-in portal-sub/init-dispatch-path [::load-report report-id]))}))))

(rf/reg-event-fx
 ::start-download
 (fn [{db :db} [_ _report-id]]
   {:db (-> db
            (assoc-in sub/download-open-path true))}))

(rf/reg-event-fx
 ::close-download
 (fn [{db :db} [_]]
   {:db (-> db
            (p/dissoc-in sub/download-context-path))}))

(rf/reg-event-fx
 ::download-items-ok
 (fn [{_db :db} [_ resp]]
   (.open js/window
          (-> resp
              :body
              :download-url)
          "_blank")
   nil))

(rf/reg-event-fx
 ::download-items-failed
 (fn [{db :db} [_ err]]
   (js/console.log "REPORT download failed : " err)
   {:db (p/dissoc-in db [::sub/loading?])}))

(rf/reg-event-fx
 ::download-items
 (fn [{db :db} [_ report-id selected-items]]
   {:db         (-> db
                    (p/dissoc-in sub/download-context-path))
    :http-xhrio (->> selected-items
                     (mapv (fn [item]
                             (let [export-item? (contains? #{:full-data-set :full-data-set-json} item)
                                   uri (case item
                                         :full-data-set      "/lp-portal/api/export-report-xls"
                                         :full-data-set-json "/lp-portal/api/export-report-json"
                                         "/lp-portal/api/download-report")]
                               {:method          :post
                                :uri             uri
                                :params          (merge {:report-id report-id}
                                                        (when-not export-item? {:selected-items [item]}))
                                :timeout         30000
                                :format          (ajax/transit-request-format)
                                :response-format (ajax/transit-response-format)
                                :on-success      [::download-items-ok]
                                :on-failure      [::download-items-failed]}))))}))

;;IF we change to downloading a ZIP
#_(rf/reg-event-fx
   ::download-items
   (fn [{db :db} [_ report-id selected-items]]
     {:db         (-> db
                      (p/dissoc-in sub/download-context-path))
      :http-xhrio
      {:method          :post
       :uri             "/lp-portal/api/download-report"
       :params          (merge {:report-id report-id}
                               {:selected-items selected-items})
       :timeout         30000
       :format          (ajax/transit-request-format)
       :response-format (ajax/transit-response-format)
       :on-success      [::download-items-ok]
       :on-failure      [::download-items-failed]}}))

(rf/reg-event-fx
 ::download-private-material
 (fn [{db :db} [_ report-id file-id]]
   {:db         (-> db
                    (p/dissoc-in sub/download-context-path))
    :http-xhrio {:method          :post
                 :uri             "/lp-portal/api/download-private-material"
                 :params          {:report-id report-id
                                   :file-id file-id
                                   :show? nil}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::download-items-ok]
                 :on-failure      [::download-items-failed]}}))
